export const scrollToElement = (elementId: string, offset = 0) => {
  const element = document.getElementById(elementId);
  if (!element) {
    //eslint-disable-next-line
    console.warn(`scrollToElement: No element found with id '${elementId}'`);
    return;
  }
  const scrollElement = element.offsetTop;
  window.scrollTo({ top: scrollElement - offset, behavior: "smooth" });
};
